import { LoginRequest } from './login-request';

export default class LoginDto implements LoginRequest {
    public readonly email: string;
    public readonly password: string;
    public readonly code?: string;
    public recaptchaToken: string;

    constructor(email: string, password: string, recaptchaToken: string, code: string) {
        this.email = email;
        this.password = password;
        this.code = code;
        this.recaptchaToken = recaptchaToken;
    }

}
